/** user roles */
export const IAR = "iar";
export const IAR_ASSISTANT = "iar_assistant";
export const IAR_PROSPECT = "iar_prospect";
export const CUSTODIAN = "custodian";
export const TPIA = "tpiatrader";
export const ADVISOR_ASSISTANT = "adv_assistant";
export const INTERNAL = "internal";
export const WHOLESALER = "wholesaler";
export const RIA_FIRM = "ria_firm";
export const CLIENT = "client";
export const RETAIL = "retail";
export const RETAIL_FP = "retail_fp";
export const BACK_OFFICE = "back_office";
export const FUNDBOARD = "fundboard";

export const ANNUITIES_FP_PATH = "/retail";
export const RIA_PATH = "/";
export const MYACCOUNT_PATH = "/client";
export const BACKOFFICE_PATH = "/backoffice";
export const FUNDBOARD_PATH = "/fundboard";
export const ENTITY_OWNED_PATH = "/entity-owned";
export const TPIA_PATH = "/tpia";
export const INTERNAL_PATH = "/internal";
export const WHOLESALER_PATH = "/wholesaler";
export const RIA_FIRM_PATH = "/riafirm";
export const MY_TEAMS_ASSISTANT_PATH = "/myteamsassist";

export const HOME_URL_PATH = "/";
export const ANNUITIES_FP_LOGIN_PAGE_URL_PATH = "/home/misc/advisor-login.html";
export const RIA_LOGIN_PAGE_URL_PATH = "/home/misc/ria-login.html";
export const MYACCOUNT_LOGIN_PAGE_URL_PATH = "/home/misc/client-login.html";
export const FUNDBOARD_LOGIN_PAGE_URL_PATH = "/authenticate/login.html";

export const REGISTRATION_SUCCESSFUL_URL_PATH =
    "/home/misc/reg-successful.html";
export const REGISTRATION_PENDING_URL_PATH = "/home/misc/reg-pending.html";

export const PRIVACY_POLICIES_URL =
    "https://www.pacificlife.com/home/privacy-and-other-policies.html";
export const LEGAL_INFO_AND_WEBSITE_USAGE_URL =
    "https://www.pacificlife.com/home/privacy-and-other-policies/legal-information-and-website-usage.html";
export const ANNUITIES_GET_APPOINTED_URL =
    "https://www.annuities.pacificlife.com/home/working-with-us/get-appointed.html";
export const ANNUITIES_CONTACT_US_URL =
    "https://www.annuities.pacificlife.com/home/misc/reg-contact/reg-contact.html";
export const RIA_STRATEGIC_ALLIANCES_URL =
    "https://ria.pacificlife.com/home/why-us/strategic-alliances.html";

export const PL_LOGO_BLACK_URL =
    "https://ria.pacificlife.com/content/dam/paclife/rsd/annuities/images/logos/pl_horiz_bw.gif";

export const VERIFY_FIRM_ID_FOR_ROLES = new Set([TPIA, RIA_FIRM]);
export const VERIFY_ADVISOR_CRD_FOR_ROLES = new Set([TPIA]);

export const ROLE_OPTIONS = [
    {
        value: "iar",
        label: "Investment Advisory Representative (IAR)"
    },
    { value: "custodian", label: "Distribution Partner/Custodian" }
];

export const REQUIRED_FIELDS = {
    [IAR]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "crd",
        "contractNumber",
        "tin",
        "id"
    ],
    [IAR_PROSPECT]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "crd",
        "id",
        "phone"
    ],
    [IAR_ASSISTANT]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "ssn4",
        "dob",
        "id"
    ],
    [CUSTODIAN]: [
        "firstName",
        "lastName",
        "email",
        "firmId",
        "ssn4",
        "dob",
        "id"
    ],
    [TPIA]: ["firstName", "lastName", "email", "firmID", "userName"],
    [RIA_FIRM]: ["firstName", "lastName", "email", "firmID", "userName"],
    [INTERNAL]: ["firstName", "lastName", "email", "userName"],
    [WHOLESALER]: ["firstName", "lastName", "email", "userName"],
    [ADVISOR_ASSISTANT]: [
        "firstName",
        "lastName",
        "email",
        "fpFirstName",
        "fpLastName",
        "userName"
    ],
    [CLIENT]: ["firstName", "lastName", "email", "contractNumber", "tin", "id"],
    [RETAIL]: [
        "firstName",
        "lastName",
        "email",
        "tin",
        "userName",
        "contractNumber"
    ],
    [RETAIL_FP]: ["firstName", "lastName", "email", "id", "optionSelect"],
    [BACK_OFFICE]: ["firstName", "lastName", "email", "tin", "id"],
    [FUNDBOARD]: ["firstName", "lastName", "email", "id"]
};
